/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SharedserviceMelcoModelsAddAlphabetCollection,
    SharedserviceMelcoModelsAddAlphabetCollectionFromJSON,
    SharedserviceMelcoModelsAddAlphabetCollectionToJSON,
    SharedserviceMelcoModelsAlphabetCollection,
    SharedserviceMelcoModelsAlphabetCollectionFromJSON,
    SharedserviceMelcoModelsAlphabetCollectionToJSON,
    SharedserviceMelcoModelsAlphabetCollectionReferences,
    SharedserviceMelcoModelsAlphabetCollectionReferencesFromJSON,
    SharedserviceMelcoModelsAlphabetCollectionReferencesToJSON,
    SharedserviceMelcoModelsError,
    SharedserviceMelcoModelsErrorFromJSON,
    SharedserviceMelcoModelsErrorToJSON,
    SharedserviceMelcoModelsGenericList1MelcoModelsAlphabetCollection,
    SharedserviceMelcoModelsGenericList1MelcoModelsAlphabetCollectionFromJSON,
    SharedserviceMelcoModelsGenericList1MelcoModelsAlphabetCollectionToJSON,
    SharedserviceMelcoModelsUpdateAlphabetCollection,
    SharedserviceMelcoModelsUpdateAlphabetCollectionFromJSON,
    SharedserviceMelcoModelsUpdateAlphabetCollectionToJSON,
} from '../models';

export interface AlphabetCollectionsDraftApiAlphabetCollectionsReferencesRequest {
    id: string;
}

export interface AlphabetCollectionsDraftApiUserAlphabetCollectionPublishRequest {
    id: string;
}

export interface AlphabetCollectionsDraftApiUserAlphabetCollectionUpdateDraftRequest {
    id: string;
    sharedserviceMelcoModelsUpdateAlphabetCollection?: SharedserviceMelcoModelsUpdateAlphabetCollection;
}

export interface AlphabetCollectionsDraftApiUserAlphabetCollectionsCreateDraftRequest {
    sharedserviceMelcoModelsAddAlphabetCollection?: SharedserviceMelcoModelsAddAlphabetCollection;
}

export interface AlphabetCollectionsDraftApiUserAlphabetCollectionsDeleteRequest {
    id: string;
    force?: boolean;
}

export interface AlphabetCollectionsDraftApiUserAlphabetCollectionsDuplicateDraftRequest {
    id: string;
}

export interface AlphabetCollectionsDraftApiUserAlphabetCollectionsGetDefRequest {
    id: string;
    publishState?: string;
}

export interface AlphabetCollectionsDraftApiUserAlphabetCollectionsGetListRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    publishState?: string;
}

export interface AlphabetCollectionsDraftApiUserAlphabetCollectionsRevertRequest {
    id: string;
}

/**
 * 
 */
export class AlphabetCollectionsDraftApi extends runtime.BaseAPI {

    /**
     */
    async alphabetCollectionsReferencesRaw(requestParameters: AlphabetCollectionsDraftApiAlphabetCollectionsReferencesRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsAlphabetCollectionReferences>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling alphabetCollectionsReferences.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alphabets/collections/{Id}/references`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsAlphabetCollectionReferencesFromJSON(jsonValue));
    }

    /**
     */
    async alphabetCollectionsReferences(requestParameters: AlphabetCollectionsDraftApiAlphabetCollectionsReferencesRequest): Promise<SharedserviceMelcoModelsAlphabetCollectionReferences> {
        const response = await this.alphabetCollectionsReferencesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userAlphabetCollectionPublishRaw(requestParameters: AlphabetCollectionsDraftApiUserAlphabetCollectionPublishRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsAlphabetCollection>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userAlphabetCollectionPublish.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alphabets/collections/{Id}/publish`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsAlphabetCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userAlphabetCollectionPublish(requestParameters: AlphabetCollectionsDraftApiUserAlphabetCollectionPublishRequest): Promise<SharedserviceMelcoModelsAlphabetCollection> {
        const response = await this.userAlphabetCollectionPublishRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userAlphabetCollectionUpdateDraftRaw(requestParameters: AlphabetCollectionsDraftApiUserAlphabetCollectionUpdateDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsAlphabetCollection>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userAlphabetCollectionUpdateDraft.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/alphabets/collections/{Id}/draft`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SharedserviceMelcoModelsUpdateAlphabetCollectionToJSON(requestParameters.sharedserviceMelcoModelsUpdateAlphabetCollection),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsAlphabetCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userAlphabetCollectionUpdateDraft(requestParameters: AlphabetCollectionsDraftApiUserAlphabetCollectionUpdateDraftRequest): Promise<SharedserviceMelcoModelsAlphabetCollection> {
        const response = await this.userAlphabetCollectionUpdateDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userAlphabetCollectionsCreateDraftRaw(requestParameters: AlphabetCollectionsDraftApiUserAlphabetCollectionsCreateDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsAlphabetCollection>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/alphabets/collections/draft`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SharedserviceMelcoModelsAddAlphabetCollectionToJSON(requestParameters.sharedserviceMelcoModelsAddAlphabetCollection),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsAlphabetCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userAlphabetCollectionsCreateDraft(requestParameters: AlphabetCollectionsDraftApiUserAlphabetCollectionsCreateDraftRequest): Promise<SharedserviceMelcoModelsAlphabetCollection> {
        const response = await this.userAlphabetCollectionsCreateDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userAlphabetCollectionsDeleteRaw(requestParameters: AlphabetCollectionsDraftApiUserAlphabetCollectionsDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userAlphabetCollectionsDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.force !== undefined) {
            queryParameters['Force'] = requestParameters.force;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alphabets/collections/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userAlphabetCollectionsDelete(requestParameters: AlphabetCollectionsDraftApiUserAlphabetCollectionsDeleteRequest): Promise<void> {
        await this.userAlphabetCollectionsDeleteRaw(requestParameters);
    }

    /**
     */
    async userAlphabetCollectionsDuplicateDraftRaw(requestParameters: AlphabetCollectionsDraftApiUserAlphabetCollectionsDuplicateDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsAlphabetCollection>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userAlphabetCollectionsDuplicateDraft.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alphabets/collections/{Id}/duplicate/draft`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsAlphabetCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userAlphabetCollectionsDuplicateDraft(requestParameters: AlphabetCollectionsDraftApiUserAlphabetCollectionsDuplicateDraftRequest): Promise<SharedserviceMelcoModelsAlphabetCollection> {
        const response = await this.userAlphabetCollectionsDuplicateDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userAlphabetCollectionsGetDefRaw(requestParameters: AlphabetCollectionsDraftApiUserAlphabetCollectionsGetDefRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsAlphabetCollection>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userAlphabetCollectionsGetDef.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alphabets/collections/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsAlphabetCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userAlphabetCollectionsGetDef(requestParameters: AlphabetCollectionsDraftApiUserAlphabetCollectionsGetDefRequest): Promise<SharedserviceMelcoModelsAlphabetCollection> {
        const response = await this.userAlphabetCollectionsGetDefRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userAlphabetCollectionsGetListRaw(requestParameters: AlphabetCollectionsDraftApiUserAlphabetCollectionsGetListRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsGenericList1MelcoModelsAlphabetCollection>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alphabets/collections`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsGenericList1MelcoModelsAlphabetCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userAlphabetCollectionsGetList(requestParameters: AlphabetCollectionsDraftApiUserAlphabetCollectionsGetListRequest): Promise<SharedserviceMelcoModelsGenericList1MelcoModelsAlphabetCollection> {
        const response = await this.userAlphabetCollectionsGetListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userAlphabetCollectionsRevertRaw(requestParameters: AlphabetCollectionsDraftApiUserAlphabetCollectionsRevertRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userAlphabetCollectionsRevert.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alphabets/collections/{Id}/revert`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userAlphabetCollectionsRevert(requestParameters: AlphabetCollectionsDraftApiUserAlphabetCollectionsRevertRequest): Promise<void> {
        await this.userAlphabetCollectionsRevertRaw(requestParameters);
    }

}
